import HatalikVerileriResponse from "src/models/GenelTanimlar/HastalikVerileriResponse";
import VwHastaliktanimlisteDTO from "src/models/HastalikTanim/VwHastaliktanimlisteDTO";
import VwHbsHastaliktanimDTO from "src/models/HastalikTanim/VwHbsHastaliktanimDTO";
import VwHbsHastaliktanimislemDTO from "src/models/HastalikTanim/VwHbsHastaliktanimislemDTO";
import VwHbsHataliktanimtaniDTO from "src/models/HastalikTanim/VwHbsHataliktanimtaniDTO";
import api from "src/services/core/api";


const controllerName = "HastalikTanim";

export const HastalikTanimApi = api.injectEndpoints({
    endpoints: builder => ({
        HastalikTanimGetir: builder.query<Array<VwHbsHastaliktanimDTO>, {}>({
            query: (request) => ({
                url: controllerName + "/HastalikTanimGetir",
                method: "GET",
                // params: request
            }),
            providesTags: ["HastalikTanim"]
        }),
        HastalikTanimEkle: builder.mutation<VwHbsHastaliktanimDTO, VwHbsHastaliktanimDTO>({
            query: (request) => ({
                url: controllerName + "/HastalikTanimEkle",
                method: "POST",
                body: JSON.stringify(request)
            }),
        }),
        HastalikTanimGuncelle: builder.mutation<VwHbsHastaliktanimDTO, {id: number, adi: string}>({
            query: (request) => ({
                url: controllerName + "/HastalikTanimGuncelle",
                method: "PUT",
                params: request
            }),
        }),
        HastalikTanimIptal: builder.mutation<boolean, {id: number}>({
            query: (request) => ({
                url: controllerName + "/HastalikTanimIptal",
                method: "DELETE",
                params: request
            }),
        }),
        HastalikTanimTaniGetir: builder.query<Array<VwHbsHataliktanimtaniDTO>, {hastalikId: number}>({
            query: (request) => ({
                url: controllerName + "/HastalikTanimTaniGetir",
                method: "GET",
                params: request
            }),
        }),
        HastalikTanimTaniEkle: builder.mutation<VwHbsHataliktanimtaniDTO, VwHbsHataliktanimtaniDTO>({
            query: (request) => ({
                url: controllerName + "/HastalikTanimTaniEkle",
                method: "POST",
                body: JSON.stringify(request)
            }),
        }),
        HastalikTanimTaniGuncelle: builder.mutation<VwHbsHataliktanimtaniDTO, VwHbsHataliktanimtaniDTO>({
            query: (request) => ({
                url: controllerName + "/HastalikTanimTaniGuncelle",
                method: "PUT",
                body: JSON.stringify(request)
            }),
        }),
        HastalikTanimTaniIptal: builder.mutation<boolean, {id: number}>({
            query: (request) => ({
                url: controllerName + "/HastalikTanimTaniIptal",
                method: "DELETE",
                params: request
            }),
        }),
        HastalikTanimIslemGetir: builder.query<Array<VwHbsHastaliktanimislemDTO>, {hastaliktanimTaniId: number}>({
            query: (request) => ({
                url: controllerName + "/HastalikTanimIslemGetir",
                method: "GET",
                params: request
            }),
            providesTags: ["HastalikTanimIslem"]
        }),
        HastalikTanimIslemEkle: builder.mutation<VwHbsHataliktanimtaniDTO, Array<VwHbsHataliktanimtaniDTO>>({
            query: (request) => ({
                url: controllerName + "/HastalikTanimIslemEkle",
                method: "POST",
                body: JSON.stringify(request)
            }),
        }),

        HastalikTanimIslemAdetGuncelle: builder.mutation<boolean, {id: number, adet:number}>({
            query: (request) => ({
                url: controllerName + "/HastalikTanimIslemAdetGuncelle",
                method: "POST",
                params: request
            }),
        }),
        HastalikTanimIslemIptal: builder.mutation<boolean, {id: number}>({
            query: (request) => ({
                url: controllerName + "/HastalikTanimIslemIptal",
                method: "DELETE",
                params: request
            }),
        }),
        MuracaataBagliHastalikIslemGetir: builder.query<HatalikVerileriResponse, {muracaatId: number}>({
            query: (request) => ({
                url: controllerName + "/MuracaataBagliHastalikIslemGetir",
                method: "GET",
                params: request
            }),
            providesTags: ["HastalikTanimIslem"]
        }),    
        HastalikTanimTaniListeGetir: builder.query<Array<VwHastaliktanimlisteDTO>, void>({
            query: () => {
                return {
                    url: controllerName + "/HastalikTanimTaniListeGetir",
                    method: "GET",
                }
            }
        })
    }),
})

export const {
    useHastalikTanimGetirQuery,
    useHastalikTanimIslemGetirQuery,
    useLazyMuracaataBagliHastalikIslemGetirQuery,
    useLazyHastalikTanimTaniGetirQuery,
    useLazyHastalikTanimIslemGetirQuery,
    useHastalikTanimEkleMutation,
    useHastalikTanimGuncelleMutation,
    useHastalikTanimIptalMutation,
    useHastalikTanimIslemEkleMutation,
    useHastalikTanimIslemIptalMutation,
    useHastalikTanimTaniEkleMutation,
    useHastalikTanimTaniGetirQuery,
    useHastalikTanimTaniGuncelleMutation,
    useHastalikTanimTaniIptalMutation,
    useLazyHastalikTanimGetirQuery,
    useMuracaataBagliHastalikIslemGetirQuery,
    useHastalikTanimIslemAdetGuncelleMutation,
    useHastalikTanimTaniListeGetirQuery,
} = HastalikTanimApi;
